import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { VentaService } from 'src/app/services/venta.service';

@Component({
  selector: 'app-opciones',
  templateUrl: './opciones.component.html',
  styleUrls: ['./opciones.component.css']
})
export class OpcionesComponent implements OnInit {

  constructor(
    private router: Router,
    public service: VentaService
  ) { }

  ngOnInit(): void {
  }

  salirVenta() {
    if (this.service.productos.length === 0) {
      return;
    }
    this.service.productos = [];
    this.service.venta = 0;
  }

  pagar() {
    if (this.service.productos.length === 0) {
      console.log('length');
      return;
    }

    if (typeof(this.service.venta) === 'string') {
      console.log('typeof');
      return;
    }

    if (this.service.venta <= 0) {
      console.log('venta');
      return;
    }

    if (this.service.venta > 100000) {
      console.log('monto');
      return;
    }

    this.router.navigateByUrl('/venta/opciones/pago');
  }

}
